import React, { useEffect, useState } from 'react';
import { AdminUI } from './ui';
import { getBoolean } from 'src/helpers/common/localStorage';
import { REACT_APP_AUTH } from 'src/utils/config';
import { setLoading } from 'src/redux/loading/loadingSlice';
import Client from 'src/model/User';
import { api } from 'src/services/api';
import { useDispatch } from 'react-redux';
import { AlertMessage } from 'src/model/AlertMessage';

export const AdminScreen: React.FC = (): JSX.Element => {
  const [signed, setSigned] = useState<boolean>(
    getBoolean(String(REACT_APP_AUTH))
  );
  const [user, setUser] = useState<Client>();
  const [alertMessage, setAlertMessage] = useState<AlertMessage[]>([]);
  const dispatch = useDispatch();

  const isAuth = async (): Promise<void> => {
    setTimeout(async () => {
      if (getBoolean(String(REACT_APP_AUTH)) !== signed) {
        setSigned(getBoolean(String(REACT_APP_AUTH)));
        return;
      } else {
        isAuth();
      }
    }, 500);
  };

  const getUser = async (): Promise<void> => {
    if (signed) {
      dispatch(setLoading(true));
      try {
        const response = await api.get<Client>(`/user/findeone`);

        if (response.status === 200) {
          setUser(response.data);
          const alert = await api.get<AlertMessage[]>(
            `/alertMessage/findAll/${response.data.id}`
          );
          setAlertMessage(alert.data);
        }
      } catch (error) {
        console.error('Erro ao buscar o usuario:', error);
      } finally {
        dispatch(setLoading(false));
      }
    } else {
      isAuth();
    }
  };

  useEffect(() => {
    isAuth();
    // eslint-disable-next-line
  }, [signed]);
  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {user ? (
        <AdminUI user={user} notifications={alertMessage} />
      ) : (
        'carregando'
      )}
    </>
  );
};
